import * as types from '../constants/actionTypes';

export function changeWeeklyQuota({userID, quota, status, data} = {}) {
    return { type: types.CHANGE_WEEKLY_QUOTA_FOR_USER, userID, quota, status, data };
}
export function cmlmLoadUsersForStaffOverview({week, status, data} = {}) {
    return { type: types.CM_LM_LOAD_USERS_FOR_STAFF_OVERVIEW, week, status, data };
}
export function loadAllUsers({status, data} = {}) {
    return { type: types.LOAD_ALL_USERS, status, data };
}
export function loadAllForUsersOverview({status, data} = {}) {
    return { type: types.LOAD_ALL_USERS_FOR_USERS_OVERVIEW, status, data };
}
export function loadCurrentUser({status, data} = {}) {
    return { type: types.LOAD_CURRENT_USER, status, data };
}
export function loadPms({status, data} = {}) {
    return { type: types.LOAD_PMS, status, data };
}
export function loadRegularUsers({status, data} = {}) {
    return { type: types.LOAD_REGULAR_USERS, status, data };
}
export function loadSponsors({status, data} = {}) {
    return { type: types.LOAD_SPONSORS, status, data };
}
export function loadUserByID({userID, status, data} = {}) {
    return { type: types.LOAD_USER_BY_ID, userID, status, data };
}
export function loadUsersByTask({taskID, status, data} = {}) {
    return { type: types.LOAD_USERS_BY_TASK, taskID, status, data };
}
export function loadUsersNoLongerAssigned({taskID, status, data} = {}) {
    return { type: types.LOAD_USERS_NO_LONGER_ASSIGNED, taskID, status, data };
}
export function setLoadingFlagForUserState() {
    return { type: types.SET_LOADING_FLAG_FOR_USER_STATE };
}
export function setSelectedUser(user) {
    return { type: types.SET_SELECTED_USER, user };
}
export function syncUsersWithLDAP({status, data} = {}) {
    return { type: types.SYNC_USERS_WITH_LDAP, status, data };
}
export function syncUserIdsWithAkira({status, data} = {}) {
  return { type: types.SYNC_USER_IDS_WITH_AKIRA, status, data };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/userActions.js
 **/